import pino from 'pino'
import { serializeError } from 'serialize-error'

export const LOGLAYER_DEFAULT_CONFIG = {
    errorSerializer: serializeError,
    metadataFieldName: 'metadata',
    contextFieldName: 'context',
}

/**
 * Shared Pino configuration for consistent log formatting across all loggers.
 * Use with pino({ ...PINO_DEFAULT_CONFIG, name: 'your-logger', level: config.logLevel })
 */
export const PINO_DEFAULT_CONFIG: pino.LoggerOptions = {
    base: undefined, // turns off pid and hostname
    formatters: {
        level: (label) => ({ level: label.toUpperCase() }),
    },
    timestamp: pino.stdTimeFunctions.isoTime,
}
